import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';

export function AdminSettings() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-4xl p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {t('admin.settings.title')}
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t('admin.settings.subtitle')}
        </p>
      </div>

      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 bg-gray-50 py-16 dark:border-gray-600 dark:bg-gray-800/50">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700">
          <Construction className="h-8 w-8 text-gray-400" />
        </div>
        <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">
          {t('admin.settings.coming_soon')}
        </h3>
        <p className="mt-2 max-w-sm text-center text-sm text-gray-500 dark:text-gray-400">
          {t('admin.settings.coming_soon_desc')}
        </p>
      </div>
    </div>
  );
}
